import { useEffect } from "react";
import { Navbar } from "@/components/sections/Navbar";
import { HeroSection } from "@/components/sections/HeroSection";
import { CTASection } from "@/components/sections/CTASection";
import { PositioningSection } from "@/components/sections/PositioningSection";
import { ServicesSection } from "@/components/sections/ServicesSection";
import { PortfolioSection } from "@/components/sections/PortfolioSection";
import { CredibilitySection } from "@/components/sections/CredibilitySection";
import { TestimonialsSection } from "@/components/sections/TestimonialsSection";
import { Footer } from "@/components/sections/Footer";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function HomePage() {
  useEffect(() => {
    // Seed data on first load
    axios.post(`${API}/admin/seed`).catch(() => {});
  }, []);

  return (
    <main className="bg-[#0A0A0A] min-h-screen">
      <Navbar />
      <HeroSection />
      <CTASection variant="top" />
      <PositioningSection />
      <ServicesSection />
      <PortfolioSection />
      <CredibilitySection />
      <TestimonialsSection />
      <CTASection variant="bottom" />
      <Footer />
    </main>
  );
}
